import { createAction } from '@reduxjs/toolkit';
import type {
  BoundaryGroupId, BoundaryTerritoryGroupId,
} from '~/store/boundaries/boundaryIdentifier.type';

export const activeDataLayersBTGIdPerBoundaryGroupChanged = createAction(
  'ACTIVE_DATA_LAYERS_BTG_ID_PER_BOUNDARY_GROUP_CHANGED',
  (boundaryGroupId: BoundaryGroupId, activeBTGId: BoundaryTerritoryGroupId) => ({
    payload: {
      boundaryGroupId,
      activeBTGId,
    },
  })
);
